import stripSearchParamsFromPathName from './stripSearchParamsFromPathName';

export default stripSearchParamsFromPathName;
